module.exports = __webpack_public_path__ + "static/media/hotel-18.286ec3a0.jpg";